import {ActionBarWrapper} from "@/components/actionBarWrapper/ActionBarWrapper.tsx";
import {FilterCategory, FilterSets} from "@/components/filterDropdown/FilterDropdown.ts";
import {SearchInput} from "@/components/searchInput/SearchInput.tsx";
import {AlertsFilters} from "@/pages/alerting/components/list/alertsControlBar/AlertsFilters.tsx";

interface AlertsControlBarProps {
  search: string;
  setSearch: (search: string) => void;
  showDeleted: string;
  setShowDeleted: (showDeleted: string) => void;
  filterSets: FilterSets<FilterCategory>;
  onFilterSetChange: (filterSet: FilterSets<FilterCategory>) => void;
}

export const AlertsControlBar = ({search, setSearch, filterSets, onFilterSetChange}: AlertsControlBarProps) => {
  return (
    <ActionBarWrapper
      className="mb-3"
      left={
        <>
          <SearchInput value={search} onChange={setSearch} variant="tableControlBar" />
          <AlertsFilters filterSets={filterSets} onFilterSetChange={onFilterSetChange} />
        </>
      }
    />
  );
};
